module.exports = __webpack_public_path__ + "./assets/c4c796f62655e45cc9684b3077484bfc.svg";